import Vue from 'vue';
import iLoadingElement from './index.vue';

const iLoadingConstructor = Vue.extend(iLoadingElement);
var instances = [],
	seed = 1;

const merge = function(target) {
	for(var i = 1, j = arguments.length; i < j; i++) {
		var source = arguments[i];
		for(var prop in source) {
			if(Object.prototype.hasOwnProperty.call(source, prop)) {
				var value = source[prop];
				if(value !== undefined) {
					target[prop] = value;
				}
			}
		}
	}
	return target;
};

const initiLoading = function() {
	const id = `iLoading${seed++}`;
	const instance = new iLoadingConstructor({
		el: document.createElement('div')
	});
	instance.id = id;
	instance.zIndex += seed;
	return instance;
}

//销毁组件
const destroyiLoading = function(instance) {
	if(!instance) {
		return;
	}
	setTimeout(()=>{
		const index = instances.findIndex(inst => instance.id === inst.id);
		instances.splice(index, 1);
		instance.$destroy();
		document.body.removeChild(instance.$el);
	}, 200)
}

//挂在实例到body，参数传入
const showiLoading = function(options) {
	const {
		onClose
	} = options;
	const instance = initiLoading();
	document.body.appendChild(instance.$el);
	Vue.nextTick(() => {
		instance.render(options);
	});
	instances.push(instance);
	instance.$on("onClose", function(res) {
		destroyiLoading(instance);
		if(typeof onClose === 'function') {
			onClose(res || '');
		}
	});
}

const iLoading = function(options) {
	showiLoading(options);
}

//entry
iLoading.render = function(options) {
	return iLoading(merge({
		message: 'Loading...',
		closeModal: false
	}, options));
}

iLoading.update = function(options) {
	const instance = instances[instances.length - 1];
	instance.message = options.message;
}

//暴力关闭
iLoading.close = function() {
	if(instances.length < 1) {
		return
	}
	const instance = instances[instances.length - 1];
	instance.isShow = false;
	destroyiLoading(instance);
}

export default iLoading;
export {
	iLoading
};